import LayoutMaster from "../components/layout/layout_master";
import Link from "next/link";
import CommentShow from "../components/view/comment_show";
import { MaxButton } from "../components/view/button";
import { useState } from "react";
import get_comment, { GetCommentResponse } from "lib/worker/api/get_comment";
import { useEffect } from "react";
import TimerComment from "components/view/timer_comment";
import get_comment_time, {
  GetCommentTimeResponse,
} from "lib/worker/api/get_comment_time";
import { AppReducerStateProps } from "lib/store";
import { CenterProps } from "lib/all_type/center_props";
import { alertWithSuccessMessage } from "components/modal/success_modal";
import commentrequest from "lib/worker/api/comment";
import { connect } from "react-redux";
import getinfo from "lib/worker/api/getinfo";
import { prefix } from "lib/worker/client";
import { GetServerSideProps } from "next";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";

interface CommentAllProps extends CenterProps {
  state: AppReducerStateProps;
  infomation: CheckWithPrefixResponse;
}

function CommentAll(props: CommentAllProps) {
  const [comments, setComments] = useState<GetCommentResponse[]>([]);
  const [commentTime, setCommentTime] = useState<GetCommentTimeResponse[]>();
  const [comment, setComment] = useState<string>("");

  useEffect(() => {
    reload();
    reloadCommentTime();
  }, []);

  const reload = () => {
    get_comment({
      prefix: prefix,
      start: comments.length,
      limit: 100,
    }).then((json) => {
      setComments([...comments, ...json]);
    });
  };

  const reloadCommentTime = () => {
    get_comment_time()
      .then((json) => {
        setCommentTime(json);
      })
      .catch((_error) => {});
  };

  const commentRequest = () => {
    const isLogin = props.state.member.isLogin;

    if (!isLogin) {
      props.alertWithMessage("กรุณาเข้าสู่ระบบก่อนคอมเม้น");
      return;
    }

    commentrequest({ text: comment })
      .then(() => {
        return get_comment({
          prefix: prefix,
          start: 0,
          limit: 100,
        });
      })
      .then((json) => {
        setComments([...json]);
        return json;
      })
      .then(() => {
        alertWithSuccessMessage("คอมเม้นสำเร็จ");
        getinfo();
        setComment("");
        reloadCommentTime();
      })
      .catch((error) => {
        props.alertWithMessage(error.response.data.message);
      });
  };

  return (
    <LayoutMaster
      content_setting={{
        title: "คอมเม้นจากผู้ใช้",
        description: "เว็บ บาคาร่า สล็อต ยิงปลา แทงบอล คาสิโนออนไลน์",
      }}
      information={props.infomation}
    >
      <div className="children-top"></div>
      <div>
        <div className="container">
          <div
            className="card card-ufa-category border-ufa-grey color-font-card"
            style={{ padding: 15 }}
          >
            <h1>
              <span>กล่องเขียนคอมเม้น</span>
            </h1>
            <textarea
              className="form-control margin-top-10 margin-bottom-10"
              id="exampleFormControlTextarea1"
              value={comment}
              onChange={(value) => {
                setComment(value.target.value);
              }}
            ></textarea>
            <div>{comment.length}/300</div>
            <div>
              <MaxButton
                title="รีวิว (รับเลย 300 uDiamond)"
                className="text-center col-8 col-md-4 col-lg-3 bg-invite button-glowing center-row-content"
                onClick={commentRequest}
              ></MaxButton>
            </div>
            {(commentTime ?? []).length != 0 && (
              <div
                style={{ paddingBottom: 10, marginTop: 6 }}
                className="row center-row-content"
              >
                <TimerComment></TimerComment>
              </div>
            )}
          </div>
        </div>
        <div className="container">
          <div className="col-12 margin-top-10">
            <div className="border-radius  shadow">
              <div className="card card-ufa-category border-ufa-grey color-font-card">
                <div className="heading margin-left-10 margin-right-10">
                  <h2 className="font-bold">
                    <span>เงื่อนไขการใช้งานกิจกรรมคอมเม้น</span>
                  </h2>
                  <p className="bottom-line-yellow"></p>
                </div>
                <div className="card-body">
                  <li>
                    คอมเม้นได้วันละ 1 ครั้ง และจะสามารถคอมเม้นได้อีกครั้งตอน 7
                    โมงเช้าของทุกวัน
                  </li>
                  <li>
                    จะได้รับ <span>uDiamond</span> ทันทีหลังจากคอมเม้น
                  </li>
                  <li>ไม่อนุญาติให้เขียนข้อความก่อกวน</li>
                  <li>
                    ท่านสามารถนำ uDiamond ไปแลกเป็นเครดิตได้{" "}
                    <Link href="/exchange">
                      <a>
                        <span>คลิกแลกเปลี่ยน uDiamond เป็นเครดิต</span>
                      </a>
                    </Link>
                  </li>
                  <li className="font-red font-bold">
                    หากผู้ใช้งานกระทำใดๆที่เป็นการก่อกวนหรือผิดเงื่อนไขนอกเนื่องจากที่ระบบยอมรับ
                    จะถูกระงับบัญชีการเล่นโดยทันที
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="card card-ufa-category border-ufa-grey color-font-card">
            <h2 className="text-center margin-top-20">
              <span>คอมเม้นทั้งหมดจากสมาชิก</span>
            </h2>
            <div>
              <div className="container">
                {(comments ?? []).map((value) => {
                  return (
                    <>
                      <CommentShow
                        User={value.Username ?? "-"}
                        Time={value.DisplayCreatedAt ?? "-"}
                        Message={value.Comment ?? "-"}
                      ></CommentShow>
                    </>
                  );
                })}
              </div>
              <div
                className="col-12 container center-row-content"
                style={{ paddingBottom: 20, marginTop: 20 }}
              >
                <MaxButton
                  title="SEE MORE"
                  className="text-center btn-purple-back"
                  onClick={reload}
                ></MaxButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(CommentAll);
